<template>
  <div>
    <v-dialog
      v-model="isSavedModalOpen"
      v-if="
        $store.state.oRstoredData &&
        $store.state.oRstoredData.length > 0 &&
        isSavedModalOpen
      "
      width="99%"
      max-width="600"
    >
      <v-card>
        <v-col align="center">
          <h2>Liste des ordres à synchroniser</h2>
        </v-col>
        <v-divider></v-divider>
        <v-col align="center">
          <v-table
            v-if="$store.state.oRstoredData && $store.state.oRstoredData.length > 0"
          >
            <thead>
              <tr>
                <th class="text-left" style="font-weight: bold">Numéro</th>
                <th class="text-left" style="font-weight: bold">Matricule</th>
              </tr>
            </thead>
            <tbody>
              <tr></tr>
              <tr
                v-for="(item, idx) in $store.state.oRstoredData.reduce((acc, current) => {
                  // Vérifier si l'objet avec le même label est déjà présent dans acc
                  if (
                    !acc.some(
                      (item) =>
                        item.data['N° RAP COMP'] === current.data['N° RAP COMP'] &&
                        item.data['N° MATR INT'] === current.data['N° MATR INT']
                    )
                  ) {
                    acc.push(current);
                  }
                  return acc;
                }, [])"
                :key="idx"
              >
                <td v-if="item.data['N° RAP COMP'] == undefined">
                  <v-chip color="grey"
                    >Numéro pas encore attribué, créé depuis le web</v-chip
                  >
                </td>
                <td v-else>
                  {{ item.data["N° RAP COMP"] }}
                </td>
                <td>{{ item.data["N° MATR INT"] }}</td>
              </tr>
            </tbody>
          </v-table>
        </v-col>
        <v-divider></v-divider>
        <v-btn
          color="#7986CB"
          style="color: white; border-radius: 0px; font-weight: bold"
          @click="sendSavedOrToServer()"
        >
          Synchroniser</v-btn
        >
      </v-card>
    </v-dialog>
    <v-dialog v-model="isOrVerificationOpen" width="auto">
      <v-card>
        <v-col style="font-weight: bold">
          Ne plus afficher
          <span style="color: red">{{ selectedOrData["N° RAP COMP"] }}</span> sur la
          web-application ?
        </v-col>
        <v-col>
          <v-row justify="center" align="center">
            <v-col cols="6" align="center">
              <v-btn color="#4CAF50" style="color: white" @click="valideSuppresion()">
                Oui
              </v-btn>
            </v-col>
            <v-col cols="6" align="center">
              <v-btn
                color="#EF5350"
                style="color: white"
                @click="isOrVerificationOpen = false"
              >
                Non
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isOrModalOpen" fullscreen persistent>
      <v-card style="overflow: auto; max-height: 90vh" color="rgb(250, 250, 250)">
        <v-col>
          <sav-form
            @close="closeModal()"
            :selectedAgency="selectedAgency"
            :getOrListeAll="getOrListeAll"
            :itemsDataLocal="itemsData"
            :technicienListe="technicienListe"
            :agenceListe="agenceListe"
            :clientListe="clientListe"
            :mainCheckListe="checkListe"
            :parcListe="parcListe"
            :stockListe="stockListe"
            :FormData="savForm"
            :optionsObj="optionsObj"
            :user="getUserInformation"
          ></sav-form>
        </v-col>
      </v-card>
    </v-dialog>
    <v-card class="mx-1" v-if="isLoading == false">
      <v-col class="pb-2">
        <v-col class="">
          <v-row align="center" justif="center">
            <v-col cols="auto">
              <h3>Liste des interventions</h3>
            </v-col>
            <v-col
              cols="py-0"
              v-if="$store.state.oRstoredData && $store.state.oRstoredData.length > 0"
            >
              <v-row justify="left" align="center">
                <v-col cols="auto" class="pt-0">
                  <v-btn
                    class=""
                    @click="isSavedModalOpen = true"
                    style="
                      color: #ffcc80;
                      font-weight: bold;
                      background-color: #f44336;
                      border: solid 1px orange;
                    "
                  >
                    <v-icon size="25px"> mdi-alert </v-icon>synchroniser
                  </v-btn>
                </v-col>
                <v-col cols="12" md="auto" class="pt-0" style="">
                  <div class="" style="font-size: 15px; color: red; font-weight: bold">
                    Les informations non synchronisées seront perdues si vous vous
                    déconnectez
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-row align="center" justify="center">
          <v-col class="pr-0" style="text-transform: uppercase">
            <v-select
              density="compact"
              bg-color="#ECEFF1"
              class="mt-2"
              label="Technicien(s)"
              variant="outlined"
              clearable
              :items="techListe"
              multiple
              v-model="selectedTech"
              hide-details
            ></v-select>
          </v-col>
          <v-col class="pl-2" style="text-transform: uppercase">
            <v-select
              density="compact"
              bg-color="#ECEFF1"
              class="mt-2"
              label="Agence"
              return-object
              item-title="ag_nom"
              variant="outlined"
              clearable
              :items="agenceListe"
              v-model="selectedAgency"
              hide-details
            ></v-select>
          </v-col>
          <v-col
            cols="auto"
            class="mt-1"
            style="position: absolute; top: 5px; right: 0px"
          >
            <v-btn
              variant="flat"
              color="rgb(92, 107, 192)"
              style="color: white"
              @click="openDialog(undefined)"
              icon
              density="compact"
              size="40"
            >
              <v-icon size="30"> mdi-plus </v-icon>
              <!-- Créer un
                            OR -->
            </v-btn>
            <v-btn
              icon="mdi-refresh"
              density="compact"
              style="font-size: 20px"
              variant="flat"
              size="40"
              @click="getOrListeAll"
              class="ml-3"
            ></v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col>
        <v-row>
          <v-col cols="6" class="py-1 pr-1">
            <v-text-field
              density="compact"
              bg-color="#ECEFF1"
              variant="outlined"
              hide-details
              v-model="search"
              label="Recherche"
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="py-1 pl-1">
            <v-select
              density="compact"
              variant="outlined"
              bg-color="#ECEFF1"
              label="Filtrer sur les OR..."
              multiple
              hide-details
              v-model="orFilterByStatut"
              :items="listeStatutToFilter"
            ></v-select>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="pt-1">
        <Vue3EasyDataTable
          :sort-by="'date_debut_location_TIMESTAMP'"
          :sort-type="'desc'"
          table-class-name="customize-table"
          ref="dataTable"
          :headers="get_tab_header"
          :items="get_or_liste_filtered"
          style="overflow: auto"
          :table-height="windowHeight - 305"
          rows-per-page-message="Ligne par colonne"
          rows-of-page-separator-message="total"
          empty-message="Aucune intervention trouvé"
          @click-row="showOr"
        >
          <template #item-Status_devis="item">
            <div align="center" class="pa-1">
              <v-chip
                v-if="item['Status devis'] == 'Signé'"
                color="white"
                style="font-weight: bold; background-color: green"
              >
                {{ item["Status devis"] }}
              </v-chip>
              <v-chip
                v-else-if="item['Status devis'] == 'en cours'"
                color="white"
                style="font-weight: bold; background-color: #ffa726"
              >
                {{ item["Status devis"] }}
              </v-chip>
              <v-chip v-else style="font-weight: bold">
                {{ item["Status devis"] }}
              </v-chip>
            </div>
          </template>
          <template #item-DATE-RAPPORT="item">
            <v-col>
              {{ formatDate(item["DATE-RAPPORT"], "DD/MM/YYYY") }}
            </v-col>
          </template>
          <template #item-date_debut_location_TIMESTAMP="item">
            <v-col v-if="item.date_debut_location_TIMESTAMP" align="center">
              {{ formatDate(parseInt(item.date_debut_location_TIMESTAMP), "DD/MM/YYYY") }}
            </v-col>
          </template>
          <template #item-date_fin_location_TIMESTAMP="item">
            <v-col v-if="item.date_fin_location_TIMESTAMP" align="center">
              {{ formatDate(parseInt(item.date_fin_location_TIMESTAMP), "DD/MM/YYYY") }}
            </v-col>
          </template>
          <template #item-delete="item">
            <div class="customize-header" align="center">
              <v-row justify="center" align="center">
                <v-col>
                  <v-btn
                    variant="flat"
                    color="#E57373"
                    style="font-size: 14px; z-index: 5"
                    @click="deleteOr(item)"
                  >
                    <v-icon color="white">mdi-delete</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </template>
          <!-- <template #item-show="item">
                        <div class="pa-1" style="">
                            <v-btn icon="mdi-open-in-app" size="35"
                                style="border-radius: 0px;font-size: 15px; width: 100%;color:white" color="#7986CB"
                                @click="showOr(item)">
                            </v-btn>
                        </div>
                    </template> -->
          <template #item-Statut="item">
            <v-col class="pa-4" style="">
              <!-- {{ item.Table }} -->
              <v-row align="center">
                <v-col class="pa-1">
                  <div v-if="item.Statut == 140">
                    <v-card
                      color="#EF9A9A"
                      class="px-4 py-1"
                      align="center"
                      variant="flat"
                      style="font-weight: bold; color: white; border: solid 1px grey"
                    >
                      Cloturé
                    </v-card>
                  </div>
                  <div v-else>
                    <v-card
                      :color="item.retour == 'oui' ? '#006064' : '#4CAF50'"
                      class="px-4 py-1"
                      align="center"
                      variant="flat"
                      style="font-weight: bold; color: white; border: solid 1px grey"
                    >
                      En cours <span v-if="item.retour == 'oui'"> RETOUR </span>
                    </v-card>
                  </div>
                </v-col>
                <!-- <v-col>
                                    {{ item.id }}
                                    {{ item['N° RAP COMP'] }}
                                </v-col> -->
                <v-col
                  class="pa-0"
                  align="center"
                  v-if="
                    $store.state &&
                    $store.state.oRstoredData &&
                    $store.state.oRstoredData.find(
                      (val) => val.data['N° RAP COMP'] == item['N° RAP COMP']
                    )
                  "
                >
                  <v-icon class="px-3" size="35px" color="red">
                    mdi-cloud-outline
                  </v-icon>
                </v-col>
              </v-row>
            </v-col>
          </template>
        </Vue3EasyDataTable>
      </v-col>
    </v-card>
    <div v-else align="center" style="padding-top: 30vh">
      <v-progress-circular
        class="mt-3"
        indeterminate
        size="200"
        :width="2"
        color="primary"
      >
        Chargement
      </v-progress-circular>
    </div>
  </div>
  <v-snackbar
    v-model="snackbarData.value"
    :timeout="2000"
    style="position: absolute; top: -80px"
    :color="snackbarData.color"
  >
    <div style="font-weight: bold">
      {{ snackbarData.text }}
    </div>
  </v-snackbar>
</template>

<script>
import savHooks from "../hooks/sav";
import SavForm from "./sav-form.vue";
import Vue3EasyDataTable from "vue3-easy-data-table";
import engine from "../core/DataApi";
import moment from "moment";
import { openDB } from "idb";

export default {
  setup() {
    const {
      clientListe,
      parcListe,
      stockListe,
      savForm,
      orListe,
      technicienListe,
      agenceListe,
      getOrListeAll,
      getUserInformation,
      checkListe,
      tableHeader,
      techListe,
      saveCopyDataAsMail,
      optionsObj,
    } = savHooks();
    return {
      clientListe,
      parcListe,
      stockListe,
      savForm,
      orListe,
      technicienListe,
      agenceListe,
      getOrListeAll,
      getUserInformation,
      checkListe,
      tableHeader,
      techListe,
      saveCopyDataAsMail,
      optionsObj,
    };
  },
  data() {
    return {
      isLoading: false,
      loadingData: {},
      selectedAgency: undefined,
      snackbarData: {},
      isSavedModalOpen: false,
      selectedTech: [],
      orFilterByStatut: ["130"],
      listeStatutToFilter: [
        { title: "Cloturé", value: "140" },
        { title: "En cours", value: "130" },
      ],
      // optionsObj: undefined,
      selectedOrData: undefined,
      isOrVerificationOpen: false,
      itemsData: undefined,
      search: "",
      windowHeight: window.innerHeight,
      isOrModalOpen: false,
    };
  },
  watch: {
    agenceListe(val) {
      console.log("agenceListe", val);
      console.log(
        "this.getUserInformation.user_id_agence",
        this.getUserInformation.user_id_agence
      );

      if (this.selectedAgency == undefined)
        this.selectedAgency = val.find(
          (val) => val.ID_Agence == this.getUserInformation.user_id_agence
        );
      console.log("selectedAgency", this.selectedAgency);
    },
  },
  mounted() {
    let query = this.$route.query;
    if (query.search) this.search = query.search;

    this.onResize();
    // this.getOrOptions()
    this.selectedTech = [this.getUserInformation.user_name];
  },
  computed: {
    get_tab_header() {
      let tab_header = this.tableHeader;

      // let listFromServ = this.tableHeader
      let list = [
        {
          value: "Statut",
          text: "Statut",
          index: -10,
        },
        {
          value: "delete",
          text: "",
          index: 99,
        },
      ];

      tab_header = tab_header.concat(list);

      for (let i = 0; i < tab_header.length; i++) tab_header[i]["sortable"] = true;

      tab_header = tab_header.sort((a, b) => a.index - b.index);

      return tab_header;
    },
    get_or_liste_filtered() {
      let liste = [];
      let tmpOr;

      if (this.selectedAgency == undefined) tmpOr = this.orListe;
      else
        tmpOr = this.orListe.filter(
          (val) => val.ID_Agence == this.selectedAgency.ID_Agence
        );

      if (this.search == undefined || this.search.length == 0) {
        liste = tmpOr;

        for (let i = 0; i < tmpOr.length; i++)
          liste[i]["DATE-RAPPORT"] = tmpOr[i]["DATE RAPPORT"];
      } else {
        for (let i = 0; i < tmpOr.length; i++) {
          let inter = tmpOr[i];
          inter["DATE-RAPPORT"] = inter["DATE RAPPORT"];
          let key =
            inter["N° RAP COMP"] +
            inter["N° MATR INT"] +
            inter["societeliv"] +
            inter["num_contrat"] +
            inter["societeliv"];

          if (key.toUpperCase().includes(this.search.toUpperCase())) liste.push(inter);
        }
      }

      if (this.selectedTech && this.selectedTech.length > 0)
        liste = liste.filter((val) =>
          this.selectedTech.includes(val["Techniciens_Nom(1)"])
        );
      if (this.orFilterByStatut && this.orFilterByStatut.length > 0)
        liste = liste.filter((val) => this.orFilterByStatut.includes(val.Statut));

      liste = liste.sort((a, b) => {
        return moment(b.CREATION).format("x") - moment(a.CREATION).format("x");
      });

      return liste;
    },
  },
  methods: {
    async deleteFromBdd(name, bdd) {
      console.log("deleteFromBdd", name, bdd);

      try {
        const db = await openDB("sav-database", 1);

        if (!db.objectStoreNames.contains(bdd)) {
          throw new Error(`Le store "${bdd}" n'existe pas.`);
        }

        await db.delete(bdd, name);
      } catch (err) {
        console.error("❌ Erreur lors de la suppression :", err);
      }
    },
    async getFromBdd(name, key) {
      try {
        // 1. Ouvrir la DB pour lire la version actuelle
        const tempDb = await openDB("sav-database");
        const currentVersion = tempDb.version;
        tempDb.close();

        // 2. Ouvrir à la bonne version
        const db = await openDB("sav-database", currentVersion);

        // alert("DB ouverte avec succès");
        // alert(`Store: ${key}`);
        // alert(`Clé: ${name}`);

        const result = await db.get(key, name);
        // alert("Lecture réussie");
        return result;
      } catch (err) {
        console.error("Erreur dans getFromBdd :", err);
        // alert("❌ Erreur : " + (err.message || err));
        return null;
      }
    },
    // async getFromBdd(name, key) {
    //   console.log("getFromBdd", name, key);
    //   alert("getFromBdd");
    //   const db = await openDB("sav-database", 1, {
    //     upgrade(db) {
    //       alert(2);
    //       if (!db.objectStoreNames.contains(key)) {
    //         db.createObjectStore(key); // Création d'un store pour les images
    //       }
    //       alert(3);
    //     },
    //   });
    //   alert(1.5);
    //   return await db.get(key, name); // Retourne l'image en base64
    // },
    async sendSavedOrToServer() {
      let savedOrList = JSON.parse(JSON.stringify(this.$store.state.oRstoredData)); // Copie de l’array

      this.isLoading = true;
      this.loadingData = {};
      for (let i = 0; i < savedOrList.length; i++) {
        console.log("sendSavedOrToServer", i);

        let ordre = savedOrList[i];
        let functionName = ordre.from;

        let savedData = await this.getFromBdd(
          ordre.key + "_" + functionName,
          "synchroData"
        );

        if (savedData) {
          this.loadingData[i] = false;
          let synchroData = JSON.parse(savedData);

          if (functionName == "creatOrSAV_FICHE") {
            await this[functionName](
              i,
              synchroData.data.finalObj,
              synchroData.data.itemsData,
              synchroData.data.items,
              synchroData.data.form,
              // synchroData.data.signed,
              synchroData.data.isBrouillon,
              synchroData,
              synchroData.data.pdfLink
            );
          } else if (functionName == "editOrSAV_FICHE") {
            this[functionName](
              i,
              synchroData.data.finalObj,
              synchroData.data.itemsData,
              synchroData.data.items,
              synchroData.data.form
            );
          } else if (functionName == "creatOrSAV2") {
            this[functionName](
              i,
              synchroData.data.finalObj,
              synchroData.data.itemsData,
              synchroData.data.items,
              synchroData.data.form,
              synchroData.data.optionsObj,
              undefined,
              synchroData.data.pdfLink
            );
          }
        }
      }
    },
    // creatOrSAV_FICHE(finalObj, itemsData, items, form, signed, isBrouillon, ordre, pdfLink) {
    async creatOrSAV_FICHE(
      idx,
      finalObj,
      itemsData,
      items,
      form,
      isBrouillon,
      ordre,
      pdfLink
    ) {
      let that = this;
      return new Promise((resolve) => {
        finalObj["IS_FROM_WEB"] = "oui";

        engine.creat_new_or_1(finalObj, async function (data) {
          if (data.code == 0) {
            console.log(0);
            let index = that.$store.state.oRstoredData.findIndex(
              (val) => val.data["N° RAP COMP"] == finalObj["N° RAP COMP"]
            );

            await that.deleteFromBdd(
              that.$store.state.oRstoredData[index].key + "_creatOrSAV_FICHE",
              "synchroData"
            );

            if (index > -1) that.$store.state.oRstoredData.splice(index, 1);
            that.$store.commit("clearOrStoredDataById", finalObj.id);

            let key = finalObj["id"] + finalObj["N° MATR INT"];
            let photoData = await that.getFromBdd(key, "synchroData");
            if (photoData) form["photos"] = JSON.parse(photoData);
            await that.deleteFromBdd(key, "synchroData");

            that.updateDropboxPhotos(idx, data.data.orNum, finalObj, form, pdfLink);
            if (Object.keys(that.$store.state.oRstoredData).length == 0)
              that.getOrListeAll();

            resolve();

            if (items.length == 0) {
              if (isBrouillon == true) {
                that.closeModal();
              } else {
                // that.creatOrSAV2(data.data.orNum, finalObj.id)
                that.creatOrSAV2(
                  idx,
                  ordre.data.finalObj,
                  ordre.data.finalObj,
                  ordre.data.items,
                  ordre.data.form,
                  ordre.data.optionsObj,
                  data.data.orNum,
                  pdfLink
                );
              }
            }
            for (let i = 0; i < items.length; i++) {
              let moteurInfo = items[i];

              let elem = {
                id: moteurInfo.id,
                "_LINK SAV": finalObj["_LINK MOTEUR"],
                id_SAV: finalObj.id,
                "SAV REF PRODUIT": moteurInfo.PIECE_REFERENCE,
                "SAV DESIGNATION": moteurInfo.PIECE_DESIGNATION,
                IS_FROM_WEB: moteurInfo.IS_FROM_WEB,
                "SAV QTE PROD": moteurInfo.qte,
                "SAV PV UNIT": undefined,
                PIECE_TOTAL: undefined,
                FLAG_DELETE: undefined,
                // ID_Societe: clientAgency.ID_Societe,
                Index_Ligne: i + 1,
              };

              if (moteurInfo.PM) elem["PM"] = moteurInfo.PM;
              engine.creat_new_moteur_1_line(elem, function () {
                if (i + 1 == items.length) {
                  if (isBrouillon == true) {
                    that.closeModal();
                  } else {
                    that.creatOrSAV2(
                      idx,
                      ordre.data.finalObj,
                      ordre.data.finalObj,
                      ordre.data.items,
                      ordre.data.form,
                      ordre.data.optionsObj,
                      data.data.orNum,
                      pdfLink
                    );
                  }
                }
              });
            }
          } else {
            console.log("OR1 ERROR");
          }
          resolve();
        });
      });
    },
    isValidJSON(str) {
      try {
        const parsed = JSON.parse(str);
        return typeof parsed === "object" && parsed !== null;
      } catch (e) {
        return false;
      }
    },
    creatOrSAV2(idx, finalObj, itemsData, items, form, optionsObj, orNum, pdfLink) {
      // console.log("creatOrSAV2");
      // console.log("finalObj", finalObj);
      // console.log("itemsData", itemsData);
      // console.log("items", items);

      let that = this;
      this.loadingData[idx] = true

      delete finalObj.STATUS_DEVIS;
      finalObj["Status devis"] = "Signé";
      finalObj["Table"] = "SAV_2";

      if (orNum) {
        finalObj["N° RAP COMP"] = orNum;
      }

      engine.creat_new_or_2(finalObj, async function (data) {
        console.log("creat_new_or_2");
        if (data.code == 0) {
          let index = that.$store.state.oRstoredData.findIndex(
            (val) => val.data["N° RAP COMP"] == finalObj["N° RAP COMP"]
          );

          if (that.$store.state.oRstoredData && that.$store.state.oRstoredData[index])
            await that.deleteFromBdd(
              that.$store.state.oRstoredData[index].key + "_creatOrSAV2",
              "synchroData"
            );

          if (index > -1) that.$store.state.oRstoredData.splice(index, 1);
          that.$store.commit("clearOrStoredDataById", finalObj.id);

          if (
            that.optionsObj.savedSignature &&
            that.optionsObj.savedSignature.length > 0
          ) {
            let key = finalObj["id"] + finalObj["N° MATR INT"];
            let picsData = await that.getFromBdd(key, "synchroData");
            if (picsData) {
              let pics = JSON.parse(picsData);
              that.saveCopyDataAsMail(
                pdfLink,
                pics,
                itemsData == undefined ? finalObj : itemsData
              );
            }
          }
          console.log("-2");

          if (
            itemsData &&
            itemsData.CARA_MATERIEL &&
            that.isValidJSON(itemsData.CARA_MATERIEL)
          ) {
            console.log("-1", itemsData.CARA_MATERIEL);
            let jsonInfo = JSON.parse(itemsData.CARA_MATERIEL);

            if (form["equipement"] == undefined) form["equipement"] = [];

            let matricule = undefined;

            if (form.materiel && form.materiel.MATRICULE)
              matricule = form.materiel.MATRICULE;
            else matricule = form.materielMatricul;

            if (
              optionsObj.auto_creat_etatdl &&
              optionsObj.auto_creat_etatdl == "1" &&
              jsonInfo &&
              jsonInfo.NUM_CONTRAT
            ) {
              engine.show_etadl(
                jsonInfo.NUM_CONTRAT,
                form["equipement"],
                matricule,
                itemsData.CARA_MATERIEL,
                itemsData.id,
                optionsObj.show_equipement_in_etadl == 1,
                itemsData.Message_Interne,
                function () {}
              );
            }
          }

          console.log(0);
          if (Object.keys(that.$store.state.oRstoredData).length == 0)
            that.getOrListeAll();
          console.log(1, items);
          for (let i = 0; i < items.length; i++) {
            console.log(2, itemsData);
            let moteurInfo = items[i];
            let elem = {
              id: moteurInfo.id,
              "_LINK SAV": itemsData["_LINK MOTEUR"],
              id_SAV: itemsData["id"],
              // "_LINK SAV": finalObj["_LINK MOTEUR"],
              // id_SAV: finalObj["id"],
              "SAV REF PRODUIT": moteurInfo.PIECE_REFERENCE,
              "SAV DESIGNATION": moteurInfo.PIECE_DESIGNATION,
              IS_FROM_WEB: moteurInfo.IS_FROM_WEB,
              "SAV QTE PROD": moteurInfo.qte,
              "SAV PV UNIT": undefined,
              PIECE_TOTAL: undefined,
              FLAG_DELETE: undefined,
              Index_Ligne: i + 1,
            };
            console.log(3, moteurInfo);
            if (moteurInfo && moteurInfo["PM"]) elem["PM"] = moteurInfo.PM;
            console.log(4);
            engine.creat_new_moteur_2_line(elem, function (moteurData) {
              console.log(5);
              console.log("creat_new_moteur_2_line", moteurData);
            });
          }
        } else {
          console.log("OR2 ERROR");
        }
      });
    },
    editOrSAV_FICHE(idx, finalObj, itemsData, items, form) {
      console.log("editOrSAV_FICHE", finalObj, itemsData, items);

      let that = this;
      console.log("edit 0", idx);

      engine.edit_or(finalObj, async function (data) {
        console.log("edit 1", idx);
        if (data.code == 0) {
          console.log("edit 2", idx);

          let index = that.$store.state.oRstoredData.findIndex(
            (val) => val.data["N° RAP COMP"] == finalObj["N° RAP COMP"]
          );

          console.log("edit 2.1", idx);

          if (
            index &&
            index > -1 &&
            that.$store &&
            that.$store.state &&
            that.$store.state.oRstoredData &&
            that.$store.state.oRstoredData[index]
          )
            await that.deleteFromBdd(
              that.$store.state.oRstoredData[index].key + "_editOrSAV_FICHE",
              "synchroData"
            );

          console.log("edit 2.1.1", idx);
          console.log("that.$store.state.oRstoredDataverif", that.$store.state);
          console.log(
            "that.$store.state.oRstoredDataverif",
            that.$store.state.oRstoredData
          );
          console.log("index", index);

          if (
            index &&
            index > -1 &&
            that.$store &&
            that.$store.state &&
            that.$store.state.oRstoredData
          )
            that.$store.state.oRstoredData.splice(index, 1);
          console.log("edit 2.2", idx);

          that.$store.commit("clearOrStoredDataById", finalObj.id);

          console.log("edit 2.3", idx);
          let key = itemsData["id"] + finalObj["N° MATR INT"];
          console.log("key", key);

          console.log("edit 3", idx);
          let picData = await that.getFromBdd(key, "synchroData");
          if (picData) form["photos"] = JSON.parse(picData);
          await that.deleteFromBdd(key, "synchroData");
          console.log("edit 4", idx);
          that.updateDropboxPhotos(idx, data.data.orNum, itemsData, form, undefined);
          console.log("delete_old_moteur_by_link", finalObj);

          engine.delete_old_moteur_by_link(finalObj["_LINK MOTEUR"], function () {
            if (Object.keys(that.$store.state.oRstoredData).length == 0)
              that.getOrListeAll();
            if (items.length == 0) that.$emit("close");
            for (let i = 0; i < items.length; i++) {
              let moteurInfo = items[i];
              if (moteurInfo["IS_FROM_WEB"] == "OUI" || moteurInfo["IS_FROM_WEB"] == "") {
                let elem = {
                  id: moteurInfo.id,
                  // id: uuid.v4(),
                  "_LINK SAV": finalObj["_LINK MOTEUR"],
                  id_SAV: itemsData.id,
                  "SAV REF PRODUIT": moteurInfo.PIECE_REFERENCE,
                  "SAV DESIGNATION": moteurInfo.PIECE_DESIGNATION,
                  "SAV QTE PROD": moteurInfo.qte,
                  "SAV PV UNIT": undefined,
                  PIECE_TOTAL: undefined,
                  FLAG_DELETE: undefined,
                  IS_FROM_WEB: "OUI",
                  // ID_Societe: clientAgency.ID_Societe,
                  Index_Ligne: i + 1,
                };

                if (moteurInfo.PM) elem["PM"] = moteurInfo.PM;

                engine.creat_new_moteur_1_line(elem, function () {
                  if (i + 1 == items.length) {
                    that.$emit("close");
                  }
                });
              }
            }
          });
        } else {
          console.log("EDIT ERROR");
        }
      });
    },

    updateDropboxPhotos(idx, num, itemsData, form, pdfLink) {
      console.log("updateDropboxPhotos", idx);

      let that = this;
      let orNum = undefined;

      if (form["photos_loaded"] == true) {
        if (num) orNum = num;
        else {
          if (itemsData && itemsData["N° RAP COMP"]) orNum = itemsData["N° RAP COMP"];
        }

        if (orNum) {
          if (pdfLink)
            engine.file_upload_with_ext(
              pdfLink,
              orNum,
              "Recap - " + moment().format("DD-MM-YYYY HHhmm") + ".pdf",
              function () {}
            );
          engine.photo_folder_liste(orNum, function (data) {
            if (data.code == 0 && data.data && data.data.length > 0) {
              let listeFileName = data.data;
              for (let i = 0; i < listeFileName.length; i++) {
                engine.photo_delete(orNum, listeFileName[i], function () {
                  if (i + 1 == listeFileName.length)
                    that.updateDropboxPhotos(idx, num, itemsData, form, pdfLink);
                });
              }
            } else {
              if (form["photos"] && form["photos"].length > 0) {
                form["photos_nbr_uploaded"] = 0;
                for (let i = 0; i < form["photos"].length; i++) {
                  console.log("upload start", i);

                  engine.file_upload(
                    form["photos"][i],
                    orNum,
                    i + 1 + " - " + moment().format("DD-MM-YYYY HHhmm"),
                    function () {
                      form["photos_nbr_uploaded"] += 1;

                      if (form["photos_nbr_uploaded"] >= form["photos"].length)
                        that.loadingData[idx] = true;

                      let loadingDataRes = Object.values(that.loadingData);

                      if (!loadingDataRes.includes(false)) {
                        console.log("finis");
                        that.isLoading = false;
                      }
                    }
                  );
                }
              } else {
                console.log("into 1");
                that.loadingData[idx] = true;
                let loadingDataRes = Object.values(that.loadingData);
                console.log("this.loadingData", that.loadingData);
                console.log("loadingDataRes", loadingDataRes);
                if (!loadingDataRes.includes(false)) {
                  console.log("finis");
                  that.isLoading = false;
                }
              }
            }
          });
        }
      } else {
        console.log("into 2");

        that.loadingData[idx] = true;
        let loadingDataRes = Object.values(that.loadingData);
        console.log("this.loadingData", that.loadingData);
        console.log("loadingDataRes", loadingDataRes);
        if (!loadingDataRes.includes(false)) {
          console.log("finis");
          that.isLoading = false;
        }
      }
    },
    // getOrOptions() {
    //     let that = this
    //     engine.get_or_options(function (data) {
    //         if (data.code == 0) {
    //             let tmpTab = data.data.data.map((val) => val.fieldData)
    //             that.optionsObj = {}
    //             for (let i = 0; i < tmpTab.length; i++) {
    //                 that.optionsObj[tmpTab[i].Name] = tmpTab[i].Value
    //                 if (tmpTab[i].Value == 'true')
    //                     that.optionsObj[tmpTab[i].Name] = true
    //                 if (tmpTab[i].Value == 'false')
    //                     that.optionsObj[tmpTab[i].Name] = false
    //             }
    //         }
    //     })
    // },
    valideSuppresion() {
      let that = this;
      if (this.selectedOrData.Table == "SAV_FICHE") {
        engine.delete_or_by_id(
          this.selectedOrData["N° RAP COMP"],
          this.selectedOrData["id"],
          function () {
            that.getOrListeAll();
            that.selectedOrData = undefined;
          }
        );
      } else {
        engine.delete_or2_by_id(
          this.selectedOrData["N° RAP COMP"],
          this.selectedOrData["id"],
          function () {
            that.getOrListeAll();
            that.selectedOrData = undefined;
          }
        );
      }
      this.isOrVerificationOpen = false;
    },
    showOr(orData) {
      if (
        this.$store.state &&
        this.$store.state.oRstoredData &&
        this.$store.state.oRstoredData.find(
          (val) =>
            val.data["N° MATR INT"] == orData["N° MATR INT"] &&
            // val.data["CLD_NUM_CONTRAT"] == orData["CLD_NUM_CONTRAT"] &&
            val.data["N° RAP COMP"] == orData["N° RAP COMP"]
        )
      ) {
        this.snackbarData = {
          value: true,
          text: "L'orde est en attente de synchronisation et n'est plus modifiable.",
          color: "red",
        };
      } else {
        if (this.isOrVerificationOpen == false) this.openDialog(orData);
      }
    },
    deleteOr(orData) {
      this.isOrVerificationOpen = true;
      this.selectedOrData = orData;
    },
    closeModal() {
      this.isOrModalOpen = false;
      // this.getOrListeAll()
    },
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    openDialog(data) {
      this.itemsData = data;
      this.isOrModalOpen = true;
    },
    formatDate(date, form) {
      let tmpDate = moment(date).format(form);
      if (tmpDate == "Invalid date") tmpDate = undefined;
      return tmpDate;
    },
  },
  components: {
    SavForm,
    Vue3EasyDataTable,
  },
};
</script>

<style>
.customize-table {
  --easy-table-border: 1px solid lightgrey;
  --easy-table-row-border: 1px solid lightgrey;

  --easy-table-header-font-size: 14px;
  --easy-table-header-font-weight: bold;
  --easy-table-header-height: 50px;
  --easy-table-header-font-color: black;
  --easy-table-header-background-color: #eceff1;

  /* --easy-table-header-item-padding: 10px 15px; */

  --easy-table-body-even-row-font-color: #fff;
  --easy-table-body-even-row-background-color: #4c5d7a;

  --easy-table-body-font-weight: bold;
  --easy-table-body-row-font-color: black;
  --easy-table-body-row-background-color: #eceff1;
  --easy-table-body-row-height: 50px;
  --easy-table-body-row-font-size: 12px;

  --easy-table-body-row-hover-font-color: black;
  --easy-table-body-row-hover-background-color: lightgray;

  /* --easy-table-body-item-padding: 10px 15px; */

  --easy-table-footer-background-color: #eceff1;
  --easy-table-footer-font-color: black;
  --easy-table-footer-font-size: 14px;
  --easy-table-footer-padding: 0px 10px;
  --easy-table-footer-height: 50px;

  --easy-table-rows-per-page-selector-width: 70px;
  --easy-table-rows-per-page-selector-option-padding: 10px;
  --easy-table-rows-per-page-selector-z-index: 1;

  /* --easy-table-scrollbar-track-color: #ECEFF1;
    --easy-table-scrollbar-color: #ECEFF1;
    --easy-table-scrollbar-thumb-color: #4c5d7a;
    --easy-table-scrollbar-corner-color: #ECEFF1; */

  --easy-table-loading-mask-background-color: #eceff1;
}
</style>
